$(".health-goals input[type=checkbox]").prop('required', true);


$(".health-goals input[type=checkbox]").click(function(){
  if ($(".health-goals input[type=checkbox]:checked").length > 0) {
     $(".health-goals input[type=checkbox]").removeAttr('required');
  }else{
  	$(".health-goals input[type=checkbox]").prop('required', true);
    alert ("Please choose at least one health goal");
  }
});

  

$('#Allergies').change(function(){
  if($('#Allergies').val() == 'Yes'){
  	$('#Allergies-Details').prop('required', true);
  }else{
    $('#Allergies-Details').removeAttr('required');
  } 
});


$('#medical-conditions').change(function(){
  if($('#medical-conditions').val() == 'Yes'){
  	 $('#Medical-Conditions-Details').prop('required', true);
  }else{
    $('#Medical-Conditions-Details').removeAttr('required');
  }
}); 

$('#medicines').change(function(){
  if($('#medicines').val() == 'Yes'){
  	$('#Prescription-Medicines').prop('required', true);
  }else{
    $('#Prescription-Medicines').removeAttr('required');
  }
}); 

$('#Cancer-Details, #Family-Cancer-Details, #Thyroid-Related-Problems-Details').hide();

$('#Cancer').click(function(){
  if($('#Cancer').is(':checked')){
  	$('#Cancer-Details').show().prop('required', true);
  }else{
    $('#Cancer-Details').hide().removeAttr('required');
  }
}); 

$('#Family-Cancer').click(function(){
  if($('#Family-Cancer').is(':checked')){
    $('#Family-Cancer-Details').show().prop('required', true);
  }else{
    $('#Family-Cancer-Details').hide().removeAttr('required');
  }
}); 

$('#Thyroid-Related-Problems').click(function(){
  if($('#Thyroid-Related-Problems').is(':checked')){
  	$('#Thyroid-Related-Problems-Details').show().prop('required', true);
  }else{
    $('#Thyroid-Related-Problems-Details').hide().removeAttr('required');
  }
}); 
  
  



$('input.btn').click(function(){

});


if($(window).width() < 768){
  $('#bgvid-hero').remove();
  
}

$('video').click(function(){
  if( $("video").prop('muted') )
    {
        $("video").prop('muted', false);
    }

    else {
    $("video").prop('muted', true);
    }
});


$('.mobile-nav__toggle-btn').click(function(){

  var subMenuID = this.getAttribute('data-aria-controls');
	var subMenu = document.getElementById(subMenuID);
	
  
  $(subMenu).slideToggle();
  
  
  

});
